import { InjectionKey } from 'vue';

import { api } from '@/plugins/chat';

const ChatSymbol: InjectionKey<typeof api> = Symbol();

const CHAT_URL_BASE = 'https://chat.irfarabi.net';

const CHAT_URL_SDK = 'https://chat.irfarabi.net/packs/js/sdk.js';

const CHAT_WEBSITE_ID = 'NQbrUUT1P5iHZ9trXKWc19ro';

const CHAT_WEBSITE_TOKEN = '2x9W4BHxtFjiReFfcjG8jKUj';

export {
  ChatSymbol,
  CHAT_WEBSITE_ID,
  CHAT_URL_SDK,
  CHAT_URL_BASE,
  CHAT_WEBSITE_TOKEN,
};
